import { PresentationTemplateWhereInput } from '@/types/schema';

const systemPresentationTemplateWhere: PresentationTemplateWhereInput = {
  systemTemplateKindNotNil: true,
};
/**
 * Filter that selects the system-owned templates surfaced as "Luminary
 * templates".
 *
 * Combine with `{ type: TENANT_TEMPLATE }` at the query's `and` level.
 */
export function useSystemPresentationTemplateWhere(): PresentationTemplateWhereInput {
  return systemPresentationTemplateWhere;
}
